import { usePage } from "@inertiajs/react"

import type { NavItem, NavigationPermission, SharedData } from "@/types"

export function useNavigationPermissions() {
  const { auth } = usePage<SharedData>().props

  const hasPermission = (
    permission: NavigationPermission | undefined,
  ): boolean => {
    if (!permission) return true

    if (permission.requireAuth && !auth) return false
    if (permission.requireStaff && !auth?.user?.staff) return false
    if (permission.customCheck) return permission.customCheck(auth)

    return true
  }

  const filterNavigationItems = (items: NavItem[]): NavItem[] => {
    return items.filter((item) => hasPermission(item.permission))
  }

  return { hasPermission, filterNavigationItems }
}
